import axios from "axios";

const state = () => ({
  uploading: false,
});

const mutations = {
  SET_UPLOADING(state, status) {
    state.uploading = status;
  },
};

const getters = {
  isUploading: (state) => {
    return state.uploading;
  },
};

const actions = {
  async uploadDefaultTeetimes({ commit, dispatch }, { courseId, payload }) {
    commit("SET_UPLOADING", true);

    const config = {
      method: "post",
      url: `${process.env.VUE_APP_API_URL}/courses/${courseId}/default_teetimes`,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + localStorage.getItem("user_token"),
      },
      data: payload,
      onUploadProgress: (progressEvent) => {
        const percentCompleted = Math.round(
          (progressEvent.loaded * 100) / progressEvent.total
        );
        console.log(`Upload progress: ${percentCompleted}%`);
      },
    };

    try {
      const response = await axios.request(config);

      dispatch(
        "toastNotification/displayToast",
        {
          message: response.data.message || "Tee times uploaded successfully",
          type: "success",
        },
        { root: true }
      );
      return "success";
    } catch (error) {
      commit(
        "toastNotification/SET_MODAL",
        {
          title: error.response?.data?.message,
          message: (() => {
            const responseData = error.response?.data;

            if (
              responseData?.errors &&
              typeof responseData.errors === "object"
            ) {
              const errorMessages = [];
              Object.values(responseData.errors).forEach((errorArray) => {
                if (Array.isArray(errorArray)) {
                  errorMessages.push(...errorArray);
                }
              });
              return errorMessages.join("\n");
            }

            return Array.isArray(responseData?.message)
              ? responseData.message.join("\n")
              : responseData?.message || "";
          })(),
          type: "error",
        },
        { root: true }
      );
      return "error";
    } finally {
      commit("SET_UPLOADING", false);
    }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
};
